import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./component/Header-Footer/Navbar";
import Footer from "./component/Header-Footer/Footer";
import Home1 from "./component/Home";
import AboutUs from "./component/AboutUs";
import Contact from "./component/Contact";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Career from "./component/Career";
import AutomationControllers from "./component/AutomationControllers";
import IndustrailAutomation from "./component/IndustrialAutomation";
import IndustrailAutomationCourses from "./component/courses/IndustrialAutomation_Courses";
import DigitalMarketing from "./component/courses/DigitalMarketing";
import Industrial_Robotics from "./component/Industrial_Robotics";
import Control_System_Design from "./component/Control_System_Design";
import Maintenance_Support from "./component/Maintenance_Support";
import Energy_Efficiency_Solutions from "./component/Energy_Efficiency_Solutions";
import AutomotiveAndTyre from "./component/AutomotiveAndTyre";
import Cement from "./component/Cement";
import Mitsubishi from "./component/Mitsubishi";
import Siemens from "./component/Siemens";
import EquipmentRepair from "./component/EquipmentRepair";
import MachineRetrofit from "./component/MachineRetrofit";
import Delta from "./component/Delta";
import Omron from "./component/Omron";
import Rockwell from "./component/Rockwell";
import Xinje from "./component/Xinje";
import Schneider from "./component/Schneider";
import Others from "./component/Others";
import Inovance from "./component/Inovance";
import Abb from "./component/Abb";
import IndustrialAutomation from "./component/IndustrialAutomation";
import InformationTechnology from "./component/courses/informationtechnology";
import Internship from "./component/courses/Internship";
import WorkShop from "./component/courses/WorkShop";
import Seminar from "./component/courses/Seminar";
import CorporateTrainings from "./component/courses/CorporateTrainings";
// import Schneider from "./component/Schneider";

// Pages Start
import Home from "../src/component/Pages/Home";

// Pages End

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/home1" element={<Home1 />} />
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<AboutUs />} />
          <Route path="/mitsubishi" element={<Mitsubishi />} />
          <Route path="/siemens" element={<Siemens />} />
          <Route path="/delta" element={<Delta />} />
          <Route path="/omron" element={<Omron />} />
          <Route path="/equipment-repair" element={<EquipmentRepair />} />
          <Route path="/rockwell_automation" element={<Rockwell />} />
          <Route path="/xinje" element={<Xinje />} />
          <Route path="/schneidar" element={<Schneider />} />
          <Route path="/others" element={<Others />} />
          <Route path="/inovance" element={<Inovance />} />
          <Route path="/abb" element={<Abb />} />
          {/* <Route path="/schneidar" element={<Schneider />} /> */}

          <Route path="/contact" element={<Contact />} />
          <Route path="/career" element={<Career />} />
          <Route path="/automotive-tyre" element={<AutomotiveAndTyre />} />
          <Route path="/cement" element={<Cement />} />
          <Route path="/machine-retrofit" element={<MachineRetrofit />} />

          <Route
            path="/automation-controllers"
            element={<AutomationControllers />}
          />
          <Route
            path="/industrail-automation"
            element={<IndustrailAutomation />}
          />
          <Route
            path="/industrial-robotics"
            element={<Industrial_Robotics />}
          />
          <Route
            path="/control-system-design"
            element={<Control_System_Design />}
          />
          <Route
            path="/maintenance-support"
            element={<Maintenance_Support />}
          />
          <Route
            path="/energy-efficiency-solutions"
            element={<Energy_Efficiency_Solutions />}
          />

          {/* courses */}
          <Route
            path="/industrail-automation-courses"
            element={<IndustrailAutomationCourses />}
          />
          <Route path="/digitalmarketing" element={<DigitalMarketing />} />
          <Route
            path="/information_technology"
            element={<InformationTechnology />}
          />
          <Route path="/internship" element={<Internship />} />
          <Route path="/workshops" element={<WorkShop />} />
          <Route path="/seminars" element={<Seminar />} />
          <Route path="/corporatetrainings" element={<CorporateTrainings />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
